import {createFeature, createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Ward} from './ward.model';
import {WardActions} from './ward.actions';

export const wardsFeatureKey = 'wards';

export interface State extends EntityState<Ward> {
  // additional entities state properties
  loading: boolean;
}

export const adapter: EntityAdapter<Ward> = createEntityAdapter<Ward>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loading: false,
});

export const reducer = createReducer(
  initialState,
  on(WardActions.addWard,
    (state, action) => adapter.addOne(action.ward, state)
  ),
  on(WardActions.upsertWard,
    (state, action) => adapter.upsertOne(action.ward, state)
  ),
  on(WardActions.addWards,
    (state, action) => adapter.addMany(action.wards, state)
  ),
  on(WardActions.wardsLoadingState, ((state, action) => {
      return {...state, loading: action?.loading};
    })
  ),
  on(WardActions.upsertWards,
    (state, action) => adapter.upsertMany(action.wards, state)
  ),
  on(WardActions.updateWard,
    (state, action) => adapter.updateOne(action.ward, state)
  ),
  on(WardActions.updateWards,
    (state, action) => adapter.updateMany(action.wards, state)
  ),
  on(WardActions.deleteWard,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(WardActions.deleteWards,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(WardActions.loadWards,
    (state, action) => adapter.setAll(action.wards, {...state, loading: false})
  ),
  on(WardActions.clearWards,
    state => adapter.removeAll(state)
  ),
);

export const wardsFeature = createFeature({
  name: wardsFeatureKey,
  reducer,
  extraSelectors: ({ selectWardsState }) => ({
    ...adapter.getSelectors(selectWardsState)
  }),
});

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

export const getLoading = (state: State) => state.loading;
